export const FaqStore = {
  catLabels: {
    quoting: "Quoting & Pricing",
    technical: "Technical",
    shipping: "Lead Time & Shipping",
  },
  categories: [
    { id: "all", icon: "ri:layout-4-line", label: "All" },
    { id: "quoting", icon: "la:file-invoice", label: "Quoting & Pricing" },
    {
      id: "technical",
      icon: "material-symbols:settings-outline",
      label: "Technical",
    },
    {
      id: "shipping",
      icon: "tabler:package-export",
      label: "Lead Time & Shipping",
    },
  ],
  faqs: [
    {
      cat: "quoting",
      q: "How do I get a quote for my parts?",
      a: "Upload your CAD drawing (STEP, IGES, DXF, or DWG) via our contact form or email it to sales@aurametals.com. Include material, surface finish, tolerance requirements, and quantity. We'll respond with a detailed quote within 4 business hours.",
      tags: ["STEP", "IGES", "4 hrs"],
    },
    {
      cat: "quoting",
      q: "Do you have a minimum order quantity?",
      a: "No strict MOQ. We accept single-unit prototypes as well as mass production runs of 10,000+ pieces. Pricing scales with volume — we'll always provide per-piece cost at different quantity tiers in the quote.",
      tags: [],
    },
    {
      cat: "quoting",
      q: "Are your prices negotiable for long-term contracts?",
      a: "Yes. For clients with recurring orders or annual blanket purchase agreements, we offer preferential pricing, dedicated capacity allocation, and priority scheduling. Contact our sales team to discuss framework agreements.",
      tags: [],
    },
    {
      cat: "quoting",
      q: "What payment terms do you offer?",
      a: "Standard terms are 50% deposit with order confirmation and 50% before shipment. Established clients may qualify for Net 30 or Net 60 terms. We accept T/T wire transfer, PayPal, and major credit cards.",
      tags: [],
    },
    {
      cat: "technical",
      q: "What tolerances can you hold?",
      a: "Our standard machining tolerance is ±0.05mm. For precision work our 5-axis centres routinely hold ±0.01mm, and our tightest capability is ±0.001mm for critical features. All toleranced features are CMM-verified before shipment.",
      tags: ["±0.001mm", "CMM"],
    },
    {
      cat: "technical",
      q: "What materials do you work with?",
      a: "We machine 30+ materials including aluminum alloys (6061, 7075), stainless steel (303, 316L), titanium (Ti-6Al-4V), brass, copper, tool steel, and engineering plastics (PEEK, Delrin). Exotic alloys available on request.",
      tags: ["Aluminum", "Titanium", "Steel", "PEEK"],
    },
    {
      cat: "technical",
      q: "Do you provide DFM feedback on my drawings?",
      a: "Yes, every quote includes a Design for Manufacturability review at no extra charge. We flag features that may increase cost or risk and suggest optimisations before machining begins.",
      tags: [],
    },
    {
      cat: "technical",
      q: "What surface finishes can you apply?",
      a: "We offer anodizing (Type II and Type III hard anodize), hard chrome plating, electroless nickel, powder coating, bead blasting, polishing, and PVD coating. Surface roughness as fine as Ra 0.4μm.",
      tags: ["Anodize", "PVD", "Ra 0.4μm"],
    },
    {
      cat: "shipping",
      q: "What is your standard lead time?",
      a: "Prototypes are typically completed in 3–5 business days. Standard production batches take 10–15 business days depending on complexity and material. Rush orders (2–3 days) are available for an additional fee.",
      tags: ["3–5 days", "Rush available"],
    },
    {
      cat: "shipping",
      q: "Do you ship internationally?",
      a: "Yes. We export to 20+ countries including the USA, UK, Germany, Japan, Australia, and the Middle East. We handle all export documentation. DHL Express, FedEx, and sea freight are available.",
      tags: [],
    },
    {
      cat: "shipping",
      q: "How are parts packaged for shipping?",
      a: "Precision parts are individually wrapped in VCI film, foam-padded, and packed in export-grade cartons. All packages include a packing list and inspection report.",
      tags: [],
    },
    {
      cat: "shipping",
      q: "Is an NDA available before sharing drawings?",
      a: "Absolutely. We will sign your NDA or provide our standard mutual NDA before you share any drawings or technical data. Confidentiality is standard practice for all client relationships.",
      tags: [],
    },
  ],
};
